import { forwardRef, type Ref, type SVGProps } from "react";
const IconInboxFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.84 17.62 24.52 5.21A2 2 0 0 0 22.68 4H9.32a2 2 0 0 0-1.84 1.21L2.16 17.62a1.9 1.9 0 0 0-.16.79V26a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-7.59a1.9 1.9 0 0 0-.16-.79M25 20h-1.59l-1.56 1.57a1.5 1.5 0 0 1-1.06.43h-9.58a1.5 1.5 0 0 1-1.06-.43L8.59 20H7a1 1 0 0 1 0-2h1.79a1.5 1.5 0 0 1 1.06.44L11.41 20h9.18l1.56-1.56a1.5 1.5 0 0 1 1.06-.44H25a1 1 0 0 1 0 2" />
  </svg>
);
const ForwardRef = forwardRef(IconInboxFilledSVG);
ForwardRef.displayName = "IconInboxFilled";
export { ForwardRef as IconInboxFilled };
